import { useEffect, useState } from 'react';
import { Notify } from './Notification';
import { exampleNotifications } from './exampleData';

export const useNotifications = () => {
  const [notifications, setNotifications] = useState<Notify[]>([]);

  useEffect(() => {
    // get data here
    setNotifications(exampleNotifications);
  }, []);

  return { notifications };
};
